import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { UnderCarriageRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: UnderCarriageRow[];
  loading?: boolean;
};

const UnderCarriageTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "subChassisId",
        label: t("UNDER_CARRIAGE.TABLE.CODE"),
        align: "right",
        width: "33.33%",
        minWidth: "33.33%",
        format: (row: UnderCarriageRow) => (
          <span className={styles.textCell}>{row.subChassisId}</span>
        ),
      },
      {
        id: "subChassisName",
        label: t("UNDER_CARRIAGE.TABLE.DESCRIPTION"),
        align: "right",
        width: "33.33%",
        minWidth: "33.33%",
        format: (row: UnderCarriageRow) => (
          <span className={styles.textCell}>{row.subChassisName}</span>
        ),
      },
      {
        id: "subChassisHeight",
        label: t("UNDER_CARRIAGE.TABLE.HEIGHT"),
        align: "right",
        width: "33.33%",
        minWidth: "33.33%",
        format: (row: UnderCarriageRow) => (
          <span className={styles.numberCell}>
            {row.subChassisHeight ?? ""}
          </span>
        ),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("UNDER_CARRIAGE.EMPTY")}
      />
    </div>
  );
};

export default UnderCarriageTable;
